import { render, staticRenderFns } from "./chatRecord.vue?vue&type=template&id=b831b596&scoped=true&"
import script from "./chatRecord.vue?vue&type=script&lang=js&"
export * from "./chatRecord.vue?vue&type=script&lang=js&"
import style0 from "./chatRecord.vue?vue&type=style&index=0&id=b831b596&lang=scss&scoped=true&"
import style1 from "./chatRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b831b596",
  null
  
)

export default component.exports